import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800 px-4">
      <div className="text-center max-w-lg">
        {/* Stylized 404 number */}
        <h1 className="font-extralight text-8xl md:text-9xl tracking-[0.4em] text-transparent bg-clip-text bg-gradient-to-r from-pink-600 via-purple-600 to-indigo-600 mb-6">
          404
        </h1>

        {/* Elegant separator line */}
        <div className="w-24 h-px bg-gradient-to-r from-transparent via-gray-300 dark:via-gray-600 to-transparent mx-auto mb-8"></div>

        {/* Error message with luxury styling */}
        <h2 className="text-2xl md:text-3xl font-thin tracking-wider uppercase text-gray-800 dark:text-gray-200 mb-4">
          Page Not Found
        </h2>

        <p className="font-light text-gray-600 dark:text-gray-400 tracking-wide mb-8">
          The page you are looking for does not exist in our atelier.
          <br />
          Perhaps you would like to explore our collection?
        </p>

        {/* Stylish button */}
        <Link
          to="/"
          className="group relative inline-flex items-center justify-center px-8 py-3 text-sm font-light tracking-wider uppercase text-white bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800 dark:from-gray-200 dark:via-gray-100 dark:to-gray-200 dark:text-gray-900 rounded-sm border border-gray-600 dark:border-gray-300 hover:shadow-lg hover:scale-105 transition-all duration-300"
        >
          <span className="relative z-10">Return to StylistGPT</span>
          <div className="absolute inset-0 bg-gradient-to-r from-gray-700 via-gray-600 to-gray-700 dark:from-gray-100 dark:via-white dark:to-gray-100 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-sm"></div>
        </Link>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-pink-600 via-purple-600 to-indigo-600 opacity-50"></div>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 opacity-50"></div>
    </div>
  );
}
